/**
 * useCockpitMode — Unified-Cockpit Modus-Detection (TQ #6906 Bundle A Phase 1).
 *
 * Seit TQ #409 kommt die Entscheidung aus der Laufzeit-Config, nicht mehr aus
 * dem Hostnamen.
 *
 * Drei Modi:
 * - `personal`: Config mode=personal (with.it-sce.de; Personal-Tenant, multi-user
 *   shared im KC-Realm Personal-Users). Kein Org-Context, Per-User-Filter im Backend.
 * - `org`: Kunden-Cockpit (z.B. cockpit.glasbrennerbaggerbetrieb.de).
 *   Org-Context aus URL/JWT abgeleitet, voller Cockpit-Funktionsumfang.
 * - `staff`: Config staffCockpit=true (cockpit.it-sce.de) mit role=itsce-staff/
 *   cortex-admin/mcp-admin. Wie org + zusätzliche IT-SCE-Intern Sektion.
 *
 * Fallback: 'org' (heutiges Verhalten — backwards-compat).
 */
import { getRuntimeConfig, type RuntimeConfig } from '../lib/runtimeConfig'

export type CockpitMode = 'personal' | 'org' | 'staff'

export function detectCockpitMode(
  cfg: Pick<RuntimeConfig, 'mode' | 'staffCockpit'>,
  isStaff: boolean,
): CockpitMode {
  if (cfg.mode === 'personal') return 'personal'
  if (cfg.staffCockpit && isStaff) return 'staff'
  return 'org'
}

export function useCockpitMode(isStaff: boolean = false): CockpitMode {
  return detectCockpitMode(getRuntimeConfig(), isStaff)
}
